<div class="data-sources">
  <div class="container">
    <div class="data-sources__header">
      <h1>Data Sources</h1>
    </div>
    <div class="data-sources__content">
      <h2>School Information</h2>
      <p>
        Data used to populate basic information about the educational institution is extracted from
        ED’s Postsecondary Education Participants System (PEPS). Individual school information
        residing in PEPS is loaded from the school’s Title IV application with ED. For assistance
        with PEPS data, please contact the School Participation Team for your state:
        <a href="https://eligcert.ed.gov/">https://eligcert.ed.gov/</a>
      </p>
      <h2>School Accreditation</h2>
      <p>
        The DoD TA DECIDE utilizes ED’s list of accrediting agencies recognized for Title IV
        purposes. All institutions must be accredited by a national or regional accrediting body
        recognized by the ED and conduct programs only from among those offered or authorized by the
        main administrative and academic office in accordance with standard procedures for
        authorization of degree programs by the educational institution. The ED recognizes
        "institutional" accreditation as well as "specialized" or "programmatic" accreditation for
        Title IV purposes as recognized specialized agencies accredit nationally. ED maintains a
        database of accredited postsecondary institutions and programs. Accreditation is a
        recognized credential for schools and some programs. The goal of accreditation is to ensure
        that the education provided by institutions of higher education meets acceptable levels of
        quality. The primary accrediting agency and type are extracted from the ED’s PEPS as
        approved on the Federal Student Aid Title IV electronic application. Accreditation is an
        important consideration if you plan to start school at one institution and transfer to
        another to complete your degree, or if you think you might “ladder” degrees (Associate,
        Bachelor’s, and Master’s). Be sure to ask any potential school about their credit transfer
        policy.
      </p>
      <p>
        Schools are accredited by private educational associations of regional or national scope.
        While the ED does not indicate whether regional or national accreditation is better, a
        recent ED study revealed that, “Nearly 90 percent of all student credit transfer
        opportunities occurred between institutions that were regionally, rather than nationally,
        accredited.”
        <a href="http://nces.ed.gov/pubs2014/2014163.pdf"
          >http://nces.ed.gov/pubs2014/2014163.pdf</a
        >
      </p>
      <p>
        For assistance with PEPS data, please click here.
        <a href="https://eligcert.ed.gov/">https://eligcert.ed.gov/</a>
      </p>
      <h2>DoD TA Participants</h2>
      <p>
        Data populated is aggregated from the Service Components (Army, Navy, Marines, and Air
        Force) as reported annually to DoD.
      </p>
      <h2>DoD Tuition Assistance (TA)</h2>
      <p>
        Data populated is aggregated from the Service Components (Army, Navy, Marines, and Air
        Force) as reported annually to DoD.
      </p>
      <h2>Post-9/11 GI Bill</h2>
      <p>
        Click here for more detailed information on GI Bill eligibility requirements and general
        program benefits.
        <a href="http://www.benefits.va.gov/gibill/comparison_tool.asp">
          http://www.benefits.va.gov/gibill/comparison_tool.asp
        </a>
      </p>
      <p>
        GI Bill Beneficiaries - The number of Veterans, Service members, and family members
        utilizing GI Bill benefits attending this institution the previous calendar year. This
        number includes all the different chapters of the GI Bill (e.g., Post-9/11, Montgomery GI
        Bill: MGIB, Reserve Education Assistance Program- REAP, and Vocational Rehabilitation).
        Please keep in mind that we include this number for informational purposes only and that
        high or low numbers of VA beneficiaries attending a particular school is not an indication
        one school is more military friendly than another. This information will be updated
        annually.
      </p>
      <p>
        Post-9/11 GI Bill Paid - The total amount of tuition and fees paid to a school on behalf of
        a student during the previous fiscal year (October 1st through September 30th).
      </p>
      <h2>Federal Student Aid</h2>
      <p>
        Financial aid to help pay for education expenses at an eligible college or career school.
        Grants, loans and work-study are types of federal student aid. These reports provide
        recipient and volume data by program for each school participating in the Title IV programs.
        Note: Each of the below forms of aid contain multiple subsets, and individual recipients
        could receive aid from more than one program type. TA DECIDE rolls these totals up, thus the
        total number of recipients may be over-reported. Click here for more detailed information on
        Federal Student Aid to include a breakdown by program
        <a href="https://studentaid.ed.gov/sa/about/data-center/student/title-iv">
          (https://studentaid.ed.gov/sa/about/data-center/student/title-iv)
        </a>
        Information on Federal Student Aid comes from the most recently reported data tables at the
        Department of Education’s website. To download these data tables, request information, or
        report data inaccuracies, please go to
        <a href="https://studentaid.ed.gov/about/data-center/student/title-iv">
          https://studentaid.ed.gov/about/data-center/student/title-iv.
        </a>
      </p>
      <p>
        Direct Loan - A federal student loan, made through the William D. Ford Federal Direct Loan
        Program, for which eligible students and parents borrow directly from ED at participating
        schools. Direct Subsidized Loans, Direct Unsubsidized Loans, Direct PLUS Loans and Direct
        Consolidation Loans are types of Direct Loans.
      </p>
      <p>
        Federal Family Education Loan (FFEL) Program - Under this program, private lenders provided
        loans to students that were guaranteed by the federal government. These loans included
        Subsidized Federal Stafford Loans, Unsubsidized Federal Stafford Loans, FFEL PLUS Loans, and
        FFEL Consolidation Loans. Federal student loans under the FFEL Program are no longer made by
        private lenders. Instead, all new federal student loans come directly from the ED under the
        Direct Loan Program.
      </p>
      <p>
        Grant - Financial aid that does not need to be repaid and is often based on financial need.
        (i.e., unless you withdraw from school and owe a refund).
      </p>
      <p>
        Work Study - A federal student aid program that provides part-time employment while you are
        enrolled in school to help pay your education expenses.
      </p>
      <h2>Programs & Offerings</h2>
      <p>
        Learning Method - Data used to populate basic information about the educational institution
        is extracted from ED’s Postsecondary Education Participants System (PEPS) and from the
        school’s active DoD MOU verification application. Click here for more detailed information
        on Federal Student Aid. <a href="https://eligcert.ed.gov/">https://eligcert.ed.gov/</a>
      </p>
      <p>
        Service members Opportunity Colleges - SOC DNS: The SOC Degree Network System (DNS) consists
        of degree-granting colleges and universities that have adopted policies outlined in the
        Voluntary Education Partnership Memorandum of Understanding (MOU) to help Service members
        and their adult family members earn college degrees. Many courses offered by SOC DNS
        institutions have two-way guaranteed transferability, making it easier for Service members
        to complete associate and bachelor’s degrees no matter where they move during their military
        careers. The SOC Degree Network System was consolidated in Fall 2014 into a 2-year
        institution and 4-year institution system without Service branch designations (SOCAD,
        SOCNAV, SOCMAR, and SOCCOAST). DNS institutions will be required to sign the most recent DoD
        MOU governing institutions providing voluntary instruction to Service members. Click here
        for more information on SOC DNS.
        <a href="http://www.soc.aascu.org/degree-network-system">
          http://www.soc.aascu.org/degree-network-system
        </a>
      </p>
      <p>
        SOC CTE: The SOC Career and Technical Education (CTE) Resource List identifies
        credit-bearing certificate programs in career and technical education fields. The CTE
        resource list was developed to assist military education counselors, academic advisers, and
        Service members with identifying career and technical education pathways to civilian careers
        with positive growth potential. The institutions and certificate programs included on the
        resource list have been carefully selected based on the program requirements outlined on the
        SOC CTE Membership page. The CTE Resource list contains 48 institutions and offers 203
        certificate programs representing specific career pathways in six Career Clusters. The
        certificate programs are offered via traditional classroom delivery, online delivery, and
        hybrid platform. Click here for more information on the SOC CTE.
        <a href="http://www.soc.aascu.org/career-and-technical-education">
          http://www.soc.aascu.org/career-and-technical-education
        </a>
      </p>
      <p>
        Degree Levels and Programs - Data used to populate basic information about the educational
        institution is extracted from ED’s Integrated Postsecondary Education Data System (IPEDS)
        and from the school’s active DoD MOU verification application. Click here for more detailed
        information on IPEDS. <a href="https://nces.ed.gov/ipeds/">https://nces.ed.gov/ipeds/</a>
      </p>
      <p>
        Classification of Instructional Programs (CIP) - The purpose of the CIP is to provide a
        taxonomic scheme that will support the accurate tracking, assessment, and reporting of
        fields of study and program completions activity. CIP was originally developed by the U.S.
        Department of Education's National Center for Education Statistics (NCES) in 1980, with
        revisions occurring in 1985 and 1990. The 2000 edition (CIP- 2000) is the third revision of
        the taxonomy and presents an updated taxonomy of instructional program classifications and
        descriptions.
      </p>

      <h2>Cost of Attendance</h2>
      <p>
        First Time, Full Time Tuition/fees (in-state) - The average in-state tuition/fees for an
        undergraduate student as reported by the school to the ED through IPEDS. Generally, in-state
        residents are charged a discounted rate of tuition and fees. Click here to view College
        Navigator.
        <a href="https://nces.ed.gov/collegenavigator/">https://nces.ed.gov/collegenavigator/</a>
      </p>
      <h2>Estimated Books/Supplies</h2>
      <p>
        The estimated cost for an undergraduate student’s room and board as reported by the school
        to the ED through IPEDS. This is the same information published on College Navigator. Note:
        For Estimated Room/Board when no data is reported, Department of Education estimates based
        on the prior year's data. Click here to view College Navigator.
        <a href="https://nces.ed.gov/collegenavigator/">https://nces.ed.gov/collegenavigator/</a>
      </p>
      <h2>Estimated Room/Board</h2>
      <p>
        The estimated cost for an undergraduate student’s room and board as reported by the school
        to the ED through IPEDS. This is the same information published on College Navigator. Note:
        For Estimated Room/Board when no data is reported, Department of Education estimates based
        on the prior year's data. Click here to view College Navigator.
        <a href="https://nces.ed.gov/collegenavigator/">https://nces.ed.gov/collegenavigator/</a>
      </p>
      <h2>DoD Tuition Assistance (TA) Information</h2>
      <p>
        DoD Tuition Assistance (TA) Data - Data populated is aggregated from the Service Components
        as reported annually to DoD.
      </p>
      <h2>Department of Education Information</h2>
      <p>
        Department of Education Data - All of the ED data provided on TA DECIDE is for the most
        recent academic year available from ED.
      </p>
      <p>
        ED Composite Scores - Section 498(c) of the Higher Education Act of 1965, as amended,
        requires for-profit and non-profit institutions to annually submit audited financial
        statements to the Department to demonstrate they are maintaining the standards of financial
        responsibility necessary to participate in the Title IV programs. One of many standards,
        which the Department utilizes to gauge the financial responsibility of an institution, is a
        composite of three ratios derived from an institution's audited financial statements. The
        three ratios are a primary reserve ratio, an equity ratio, and a net income ratio. These
        ratios gauge the fundamental elements of the financial health of an institution, not the
        educational quality of an institution. Click here to view ED composite scores.
        <a href="https://studentaid.gov/data-center/school/composite-scores">
          https://studentaid.gov/data-center/school/composite-scores
        </a>
      </p>
      <p>
        ED 90/10 Rule - Section 487(d)(4) of the Higher Education Act of 1965 (HEA), as amended,
        requires the Secretary to annually submit a report to Congress containing information
        regarding the amount and percentage of each proprietary institution's revenues from Title IV
        sources and non-Title IV sources as provided by the institution in its audited financial
        statements. This information relates to the requirement that a for-profit institution of
        postsecondary education derive at least 10 percent of its revenue from non- Title IV sources
        (the 90/10 rule). The 90/10 rule was amended by the enactment of the Higher Education
        Opportunity Act (HEOA) in 2008 to permit an institution that fails the 90/10 requirement for
        one year to continue its eligibility to participate in the Title IV programs. However, the
        institution’s participation would become provisional for two fiscal years. If the
        institution does not satisfy the 90/10 rule for two consecutive fiscal years, it would lose
        its eligibility to participate in the Title IV programs for at least the following two
        fiscal years. This two-year provision was effective upon enactment of the HEOA of August 14,
        2008. Click here to view ED’s 90/10.
        <a href="https://studentaid.gov/data-center/school/proprietary">
          https://studentaid.gov/data-center/school/proprietary
        </a>
      </p>
      <p>
        Median Borrowing - The median amount of Federal student loans borrowed for students'
        undergraduate study at the institution is displayed. Data used to calculate the median
        amount of Federal student loans borrowed by students for their undergraduate study is from
        the U.S. Department of Education’s National Student Loan Data System (NSLDS). Data represent
        all undergraduate borrowers who graduated or withdrew from the institution between July 1,
        2010, and June 30, 2011. All Federal loans for undergraduate study, including Parent PLUS
        loans, are included for this cohort of borrowers. Only the debt associated with the
        students’ attendance at the institution is included in the calculation. The estimated
        monthly repayment amount has been calculated using the Department’s standard graduated
        repayment calculator based on an interest rate of 6.8%. Click here for more information
        about repayment calculators and interest rates. Note that a student’s actual borrowing,
        interest rate, and monthly repayment amount may be different.
        <a href="https://studentaid.gov/h/understand-aid/how-aid-works">
          https://studentaid.gov/h/understand-aid/how-aid-works
        </a>
      </p>
      <h2>Complaint Information</h2>
      <p>
        DoD Tuition Assistance (TA) Complaint Data - Data populated is aggregated from the DoD
        Postsecondary Education Complaint System (PECS). The DoD PECS is a centralized online
        reporting system that allows service members and their families to provide feedback about
        education institutions. The initiative, part of the president’s Executive Order for
        Principles of Excellence, empowers students and their families to report experiences related
        to misleading or unfair acts or practices by education institutions. Note: Complaints can
        include multiple categories.
      </p>
      <p>
        VA Complaint Data - Data populated is aggregated from the VA GI Bill Feedback System. Note:
        Complaints can include multiple categories. Click here for more information on the GI Bill
        Feedback System.
        <a href="http://www.benefits.va.gov/GIBILL/Feedback.asp">
          http://www.benefits.va.gov/GIBILL/Feedback.asp
        </a>
      </p>
      <h2>School Eligibility</h2>
      <p>Department of Defense</p>
      <p>
        DoD Memorandum of Understanding (MOU) - The Department of Defense Instruction (DoDI)
        1322.25, Voluntary Education Programs, Change 3, establishes Voluntary Education policy;
        states eligibility criteria for tuition assistance (TA); institutionalizes within DoD the
        Principles of Excellence in support of Executive Order 13607 (April 27, 2012); and requires
        educational institutions that wish to participate in the DoD Tuition Assistance (TA) Program
        to sign a MOU conveying the commitments and agreements between the educational institution
        and DoD prior to receiving funds from a service’s TA program. Note: Only educational
        institutions eligible to participate in the TA program are available through TA DECIDE.
        Click here to read more about the DoD Voluntary Education Partnership MOU.
        <a href="https://www.dodmou.com/"> https://www.dodmou.com/ </a>
      </p>
      <p>Department of Veterans Affairs</p>
      <p>
        Principles of Excellence - The Principles of Excellence is a voluntary initiative through
        the Department of Veterans Affairs. Schools that agree to participate will:
      </p>
      <ul>
        <li>
          Provide students with a personalized form covering the total cost of an education program.
        </li>
        <li>Provide educational plans for all Military and Veteran education beneficiaries.</li>
        <li>End fraudulent and aggressive recruiting techniques and misrepresentation.</li>
        <li>
          Provide accommodations for Service Members and Reservists absent due to service
          requirements.
        </li>
        <li>Designate a Point of Contact for academic and financial advising.</li>
        <li>Ensure accreditation of all new programs prior to enrolling students.</li>
        <li>Align institutional refund policies with those under Title IV.</li>
      </ul>
      <p>
        Click here for more information on VA’s work on the Principles of Excellence criteria.
        <a href="http://www.benefits.va.gov/gibill/comparison_tool/about_this_tool.asp#principles">
          http://www.benefits.va.gov/gibill/comparison_tool/about_this_tool.asp#principles
        </a>
      </p>
      <p>
        Yellow Ribbon - The Post-9/11 GI Bill can cover all in-state tuition and fees at public
        degree granting schools, but may not cover all private degree granting schools and
        out-of-state tuition. The Yellow Ribbon Program provides additional support in those
        situations. Institutions voluntarily enter into an agreement with VA to fund uncovered
        charges. VA matches each dollar of unmet charges the institution agrees to contribute, up to
        the total cost of the tuition and fees.
      </p>
      <p>
        Only Veterans entitled to the maximum benefit rate (based on service requirements) or their
        designated transferees may receive this funding. Active duty Service members and their
        spouses are not eligible for this program (child transferees of active duty service members
        may be eligible if the service member is qualified at the 100% rate). Click here to read
        more about VA’s Yellow Ribbon Program.
        <a href="http://www.benefits.va.gov/GIBILL/yellow_ribbon.asp">
          http://www.benefits.va.gov/GIBILL/yellow_ribbon.asp
        </a>
      </p>
      <p>Department of Education</p>
      <p>
        8 Keys to Veterans Success - The 8 Keys is a voluntary initiative through the Department of
        Education. Schools that agree to participate will:
      </p>
      <ul>
        <li>
          Create a culture of trust and connectedness across the campus community to promote
          well-being and success for veterans.
        </li>
        <li>Ensure consistent and sustained support from campus leadership.</li>
        <li>
          Implement an early alert system to ensure all veterans receive academic, career, and
          financial advice before challenges become overwhelming.
        </li>
        <li>
          Coordinate and centralize campus efforts for all veterans, together with the creation of a
          designated space for them (even if limited in size).
        </li>
        <li>
          Collaborate with local communities and organizations, including government agencies, to
          align and coordinate various services for veterans.
        </li>
        <li>
          Utilize a uniform set of data tools to collect and track information on veterans,
          including demographics, retention, and degree completion.
        </li>
        <li>
          Provide comprehensive professional development for faculty and staff on issues and
          challenges unique to veterans.
        </li>
        <li>Develop systems that ensure sustainability of effective practices for veterans.</li>
      </ul>
      <p>
        Click here to read more about ED’s 8 Keys to Veterans Success.
        <a href="https://www.ed.gov/veterans-and-military-families/8-keys-success-sites">
          https://www.ed.gov/veterans-and-military-families/8-keys-success-sites
        </a>
      </p>
    </div>
  </div>
</div>
